import { getBasePath } from '@/utils/utils';
import { DownloadPage } from '@op/pages/download';
import { DownloadProps } from '@op/pages/download/types';
import { clearDownloadStorage } from '@op/utils/storageUtils';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function Download() {
  return (
    <DownloadPage gameInfo={undefined} wholeGameInfo={undefined}></DownloadPage>
  );
}

export async function gotoDownload({
  key,
  fileName,
  filter,
  auxiliaryParams,
  data,
}: DownloadProps) {
  const storageParams = {
    key,
    fileName,
    filter,
    auxiliaryParams,
    data,
    downloadTime: new Date().getTime(),
  };

  const downloadId = uuidv4();
  try {
    // 后续转为带有标识的
    localStorage.setItem(
      `downLoadParams-${downloadId}`,
      JSON.stringify(storageParams),
    );
  } catch (error) {
    console.log(error);
    clearDownloadStorage();
    localStorage.setItem(
      `downLoadParams-${downloadId}`,
      JSON.stringify(storageParams),
    );
  }

  (window as any).aegis?.infoAll?.(
    JSON.stringify({
      action: 'download',
      downloadId,
      storageParams,
    }),
  );

  window.open(`${getBasePath()}/marketing/Download?id=${downloadId}`, '_blank');
}
